const CHUNK_ERROR_PATTERNS = [
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "error loading dynamically imported module",
  "Unable to preload CSS",
];

// A stale chunk can resolve to `undefined` instead of rejecting. React.lazy then
// reads `.default` off it and throws a plain TypeError, which matches none of the
// messages above. Only `.default` reads match, so unrelated ones are left alone.
const UNDEFINED_MODULE_DEFAULT_PATTERNS = [
  /Cannot read properties of undefined \(reading 'default'\)/,
  /Cannot read property 'default' of undefined/,
  /undefined is not an object \(evaluating '[^']*\.default'\)/,
  /can't access property "default"/,
];

// Exported so the diagnostics builder reads messages the same way this does.
export const messageOf = (error: unknown): string => {
  if (typeof error === "string") return error;
  if (error instanceof Error) return error.message;
  if (error && typeof error === "object" && "message" in error) {
    return String((error as { message: unknown }).message ?? "");
  }
  return "";
};

// True when an error looks like a failed chunk/import load.
export const isChunkLoadError = (error: unknown): boolean => {
  if (error instanceof Error && error.name === "ChunkLoadError") return true;
  const message = messageOf(error);
  return (
    CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern)) ||
    UNDEFINED_MODULE_DEFAULT_PATTERNS.some((pattern) => pattern.test(message))
  );
};
